var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.05 39H23v-7.95A9 9 0 0 0 15.05 39zM25 31.05V39h7.95A9 9 0 0 0 25 31.05zM32.95 41a8.94 8.94 0 0 1-1.15 3.5l1.73 1a11 11 0 1 0-19.06 0l1.73-1c-.6-1.05-1-2.24-1.15-3.5h17.9z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 40a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM31.58 36.84A2 2 0 0 1 33 34.4l1.93-.52a2 2 0 0 1 2.45 1.41l1.04 3.87A2 2 0 0 1 37 41.6l-1.93.51a2 2 0 0 1-2.45-1.41l-1.04-3.87zM10.62 35.3a2 2 0 0 1 2.45-1.42l1.93.51a2 2 0 0 1 1.42 2.45l-1.04 3.87a2 2 0 0 1-2.45 1.41L11 41.6a2 2 0 0 1-1.42-2.45l1.04-3.86z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 17v-3h2v3a7 7 0 1 0 14 0v-3h2v3a9 9 0 1 1-18 0zM13.8 11h20.45l.23-.65v-.04A9.2 9.2 0 0 0 35 7.1c0-.8-.52-1.48-1.2-2.01-.7-.54-1.66-1-2.72-1.38A22.5 22.5 0 0 0 24 2.5c-2.27 0-4.95.45-7.08 1.2a9.97 9.97 0 0 0-2.71 1.39c-.69.53-1.21 1.2-1.21 2 0 1.47.25 2.25.5 3.04l.07.22c.07.25.15.47.22.65zM20 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.02 13.41a.52.52 0 0 1 .52-.41h18.92c.26 0 .47.17.52.41v.03a1.3 1.3 0 0 1 .02.23c0 .14-.01.33-.07.56-.1.47-.38 1.06-1 1.63C31.7 16.99 29.16 18 24 18s-7.7-1-8.93-2.14a3.21 3.21 0 0 1-1-1.63 2.4 2.4 0 0 1-.05-.79v-.02z",
    fill: "#fff"
  })));
});